module.exports = __webpack_public_path__ + "cancellara-live-dist/img/customer-care.7330c391.jpg";